// Shared sx styles for tightening row spacing in data tables across v2 tabs

// Opt-in header treatment for v2 tables. DataRow's default gives every header cell its own
// grey fill, which the 16px column gutters break into detached pills; this drops the fills for
// a single rule under the row. Cell padding is untouched, so header and data stay aligned.
export const tableHeaderSx = {
  borderBottom: '2px solid rgba(0,0,0,0.12)',
  '& .MuiGrid-root.MuiGrid-item > *': {
    background: 'transparent',
    color: 'rgba(0,0,0,0.6)',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
};

export const tightTableSx = {
  overflowX: 'auto',
  '& > .MuiGrid-container': {
    paddingTop: '4px !important',
    paddingBottom: '4px !important',
    marginBottom: '0 !important',
  },
  '& .MuiGrid-item > .MuiBox-root': {
    paddingTop: '8px !important',
    paddingBottom: '8px !important',
  },
};
